/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";

import { errorHandler, options } from "./index";
// import history from '../history/index';
import types from "../actions/types";
import { API_URL } from "../config";
import { toast_notifications } from "../utils/notifications";
// import STATIC_ROUTES from '../route/STATIC_ROUTES';

export function getUserById(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/user/getUserById", body, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.FETCH_USER,
          payload: response.data,
        });

        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

// export function getUserByIdNew(body) {
//   return async (dispatch) => {
//     try {
//       const response = await axios(options(API_URL + "/user/getUserById", body, "post"));
//       const responseOK = response && response.status === 200 && response.statusText === "OK";
//       if (responseOK) {
//         return response.data;
//       }
//     } catch (error) {
//       console.warn("Error:", error);
//       dispatch(errorHandler(error));
//     }
//   };
// }

export function updateUser(body) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/user/update", body, "put"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        // dispatch({
        // 	type: types.SIGN_IN,
        // 	message: 'Welcome. Successfully sign in!',
        // 	user: response.data,
        // });
        toast_notifications.success("Successfully updated user!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateUserProjects(body) {
  return async (dispatch) => {
    try {
      await axios(options(API_URL + "/user/updateProjects", body, "put"));
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function updateUserTools(body) {
  return async (dispatch) => {
    try {
      await axios(options(API_URL + "/user/updateTools", body, "put"));
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function isUserExists(username) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/user/isUserExists", { username }, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function isUserEmailExists(email) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/user/isUserEmailExists", { email }, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function sendMailForDownloadFile(user) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/user/sendMailForDownloadFile", user, "post")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export const usersService = {
  getAllUsers: (data) =>
    axios(options(API_URL + `/admin/users?status=${data?.status || ""}`, {}, "get")),
  getUserById: (data) => axios(options(API_URL + `/users/user`, {}, "get", data)),
  getUserInfoById: (data) => axios(options(API_URL + `/userInfo/${data}`, {}, "get")),
  updateUser: (data) => axios(options(API_URL + "/user/update", data, "put")),
  updateUserAccount: (data) => axios(options(API_URL + "/user/updateAccount", data, "put")),
  getUsersByCompanyId: (data) => axios(options(API_URL + `/usersByCompanyId/${data}`, {}, "get")),
  accessToSimApp: (data) => axios(options(API_URL + `/sim-access`, data, "post")),
  openSimApp: (data) => axios(options(API_URL + `/sim-open`, data, "post")),
};
